<template>
  <!-- 选择项配置组件
       @author: 王汝鹏
       @date: 2019-9-10
   -->
  <div class="setting-item">
    <el-form-item class="setting-options" label="选择项"> 
      <el-radio-group v-model="radio">
        <el-radio-button label="静态数据"></el-radio-button>
        <el-radio-button label="远端数据" disabled></el-radio-button>
      </el-radio-group>
      <!-- 静态数据 -->
      <div class="static-data">
        <!-- 如果是单选组件或者下拉选择器单选，默认值只能选一个 -->
        <div v-if="value.node.type == 'radio' || (value.node.type == 'select' && !selectMultiple)">
          <el-radio-group v-model="defaultValue">
            <div class="option-item" v-for="(item,i) in options" :key="i">
              <el-radio :label="item.label" :key="item.label"></el-radio>
              <el-input class="option-item_label" placeholder="请输入内容" :value="item.value" @input="(value) => editOptionValue(item, value)"></el-input>
              <el-input class="option-item_value" v-show="false" placeholder="请输入内容" v-model="item.label"></el-input>
              <i class="option-delete_button el-icon-minus" @click="deleteOption(i)"></i>
            </div>
          </el-radio-group>
        </div>
        <!-- 如果是多选类或者下拉选择器多选，默认值可设置多个 -->
        <div v-if="value.node.type == 'checkbox' || (value.node.type == 'select' && selectMultiple)">
          <el-checkbox-group v-model="defaultValue">
            <div class="option-item" v-for="(item,i) in options" :key="i">
              <el-checkbox :label="item.label" :key="item.label"></el-checkbox>
              <el-input class="option-item_label" placeholder="请输入内容" :value="item.value" @input="(value) => editOptionValue(item, value)"></el-input>
              <el-input class="option-item_value" v-show="false" placeholder="请输入内容" v-model="item.label"></el-input>
              <i class="option-delete_button el-icon-minus" @click="deleteOption(i)"></i>
            </div>
          </el-checkbox-group>
        </div>
        <!-- 添加选项按钮 -->
        <el-button class="option-add_button"
                   type="text"
                   @click="addOption">添加选项</el-button>
      </div>
      <!-- 远端数据 -->
      <div class="remote-data">
      </div>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入工具类
import { produceNumber } from "@/utils/utils.js"
export default {
  mixins: [ mixValueWatch ],
  data() {
    return {
      radio: "静态数据"
    }
  },
  computed: {
    ...mapComputed({
    /** @name 基础属性-选择项
     *  @description 将 options 字段映射到当前 options 计算属性
     *  @return {Array}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
      options: { 
        parent: i => i.baseOption,
        attr: "options"
      },
    /** @name 基础属性-默认值
     *  @description 将 defaultValue 字段映射到当前 defaultValue 计算属性
     *  @return { String || Array }
     *  @author liuguisheng
     *  @version 2020-1-4
     */
      defaultValue: {
        parent: i => i.baseOption,
        attr: "defaultValue"
      }
    }),
    /**
     * @name 下拉选择器是否多选判断
     * @description 因为下拉选择器既可以多选也可以单选，所以要根据当前设置判断选项默认值如何配置
     * @returns { Boolean || String } 如果是下拉组件返回是否多选，否则为空
     * @author liuguisheng
     * @version 2020-1-5
     */
    selectMultiple () {
      return this.value.node.type == 'select' ? this.value.baseOption.multiple : undefined
    }
  },
  methods: {
    /** @name 删除选项项
     *  @param {Number} index 选项索引
     *  @author 王汝鹏
     *  @version 2019-09-15
     */
    deleteOption(index) {
      let newOptions = [...this.options];
      newOptions.splice(index,1);
      this.options = newOptions;
    },
    /** @name 添加选择项
     *  @author 王汝鹏
     *  @version 2019-09-15
     */
    addOption() {
      let newOptions = [...this.options];
      let item = produceNumber(4, false)
      newOptions.push({value:`选项${item}`, label:`选项${item}`, node:{}});
      this.options = newOptions;
    },
    /** @name 更新选择项内容值
     *  @param {Object} item 选择项配置
     *  @param {String} value 选择项的值
     *  @author 王汝鹏
     *  @version 2020-01-11
     */
    editOptionValue(item, value) {
      item.label = item.value = value;
      if (Boolean(value) === false) { item.label = ' '; } 
      this.options = [...this.options];
    }
  },
  watch: {
    /**
     * @name 下拉选择器是否多选监听
     * @author liuguisheng
     * @version 2020-1-5
    */
    selectMultiple (newValue) {
      this.defaultValue = newValue ? [] : '';
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingOptions.vue